import { Injectable } from '@angular/core';
import { Share } from "@capacitor/share";
import {LayoutService} from "./layout.service";
import {translation} from "../translation";

@Injectable({
  providedIn: 'root'
})
export class ShareService {

  public baseUrl = translation.website_base_url;
  public webAppUrl = this.baseUrl + `/${translation.path_hymn}/`;
  public playStoreUrl = translation.url_play_store;
  public appStoreUrl = translation.url_app_store;

  constructor(private layoutService: LayoutService) { }

  suggestCorrection(hymn: any) {
    const message = translation.correction_message + '\n\n\n' + this.hymnAsText(hymn);
    const subject = translation.correction_subject + " " + hymn.hymnNumber;
    const email = translation.correction_email;

    const url = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;

    window.open(url);
  }

  shareHymn(hymn: any) {
    Share.share({
      text: this.hymnAsText(hymn) + '\n\n' + this.webAppUrl + Number(hymn.hymnNumber)
    });
  }

  shareApp() {
    Share.share({
        text: translation.share_message
    });
  }

  public hymnAsText(hymn: any, newline = '\n'): string {
    let hymnText = `${translation.hymn} ${hymn.hymnNumber} - ${hymn.title}`;

    hymnText += `${newline}${newline} ${translation.verse} 1${newline}${hymn.verses[0].content.join(newline)}`;

    if (hymn.hasChorus) {
      hymnText += `${newline}${newline} ${translation.refrain}${newline}${hymn.chorus.join(newline)}`;
    }

    for (let i = 1; i < hymn.verses.length; i++) {
      hymnText += `${newline}${newline} ${translation.verse} ${(i + 1)}${newline}${hymn.verses[i].content.join(newline)}`;
    }

    return hymnText;
  }
}
